import WORDING from 'constants/wording'

const { O_INGRESA_AQUI } = WORDING

function Separator({ text = O_INGRESA_AQUI, className = '' }) {
  return (
    <div className='my-3 w-full justify-center items-center flex'>
      <hr className='border w-full bg-color-gray-500 border-gray-500' />
      <div className='shrink-0'>
        <span className={`font-bold text-gray-600 text-xs px-1 ${className}`}>
          {text}
        </span>
      </div>
      <hr className='border w-full border-gray-500' />
    </div>
  )
}

export default Separator
